import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { Ride99LinkCard } from './ui/ride99_link.js';

export { Ride99LinkCard } from './ui/ride99_link.js';

/**
 * Entrada de catálogo do `ride99_link` (slot chat). Policy igual à do `wallet_link`: o
 * botão só abre a folha da 99 (`open-ride99`, client-side, sem turno nem challenge) — vale
 * depois de qualquer resposta (`freezeWhenSupersededBy: []`); cada emissão ancora na própria
 * mensagem (`reconcileById: false`).
 */
export const ride99LinkEntry: GenUiEntry<Extract<ChatUi, { kind: 'ride99_link' }>> = {
  kind: 'ride99_link',
  slot: 'chat',
  policy: { reconcileById: false, freezeWhenSupersededBy: [] },
  render: ({ readOnly, dispatch }) => <Ride99LinkCard readOnly={readOnly} dispatch={dispatch} />,
};
